import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import MetricsAPI from "@/api/Metrics/Metrics.js";
import CoreWidget from "./CoreWidget";
import { timezone } from "@/utils/timezoneResolver";

const CasesSummaryWidget = () => {
  const metrics = [
    {
      metric: "casesSummary",
      args: [
        timezone,
        moment().startOf("month").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
    },
    {
      metric: "casesSummary",
      args: [
        timezone,
        moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
        moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
      ],
    },
  ];

  const { data } = useQuery({
    queryKey: ["metrics", { metrics }],
    queryFn: () => MetricsAPI.getMetrics({ metrics }),
  });

  if (!data) return null;

  const casesSummaryThisMonth = data?.data?.[0]?.casesSummary || {};
  const casesSummaryLastMonth = data?.data?.[1]?.casesSummary || {};

  // calculate percentage change
  let percentageChange: number | string =
    ((casesSummaryThisMonth.cases_count - casesSummaryLastMonth.cases_count) /
      casesSummaryLastMonth.cases_count) *
    100;

  percentageChange = percentageChange.toFixed(2);

  const caseSummaryDetails = [
    {
      label: "Active",
      value: casesSummaryThisMonth?.active_count || 0,
    },
    {
      label: "Closed",
      value: casesSummaryThisMonth?.closed_count || 0,
    },
  ];

  const casePluralDisplay =
    casesSummaryThisMonth.cases_count > 1 ? "Cases" : "Case";

  return (
    <>
      <CoreWidget
        statTitle="Case Summary (This Month)"
        statValue={`${casesSummaryThisMonth.cases_count} ${casePluralDisplay}`}
        percentageChange={percentageChange}
        detailItems={caseSummaryDetails}
      />
    </>
  );
};

export default CasesSummaryWidget;
